var map = {
	"./CSA-logo-w.svg": 1023,
	"./CSA-logo.svg": 1024,
	"./CSA_preview.png": 1025,
	"./GDA-logo-w.svg": 1026,
	"./GDA-logo.svg": 1027,
	"./GDA_preview.png": 1028,
	"./GDPO-logo-w.svg": 1029,
	"./GDPO-logo.svg": 1030,
	"./GDPO_preview.png": 1031,
	"./GORDIC-cyber-security-logo-w.svg": 1032,
	"./GORDIC-cyber-security-logo.svg": 1033,
	"./GORDIC-logo-w.svg": 1034,
	"./PDIL-logo-w.svg": 1035,
	"./PDIL-logo.svg": 1036,
	"./PDIL_preview.png": 1037
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1022;